import axios from 'axios';
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type GetUserTokenPayload = { email: string };
type GetUserTokenResponse = any;

export class UserNotFoundError extends Error {
  constructor() {
    super('No account found with that email. Please sign up first.');
    this.name = 'UserNotFoundError';
  }
}

export const getUserToken = async (
  payload: GetUserTokenPayload
): Promise<GetUserTokenResponse> => {
  try {
    const { data } = await apiService.post<GetUserTokenResponse>('/users', {
      ...payload,
      is_login: true
    });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      throw new UserNotFoundError();
    }
    throw handleAxiosError(error);
  }
};
